<script lang="ts">
    import IconifyIcon from '@iconify/svelte'
    import linkedin from '@iconify/icons-fa-brands/linkedin'
    import learnMore from 'src/components/main/#assets/learn-more.svg'

    let showAll = false
</script>

<div class="lines-wrapper notranslate">
    <div class="background-line"></div>
    <div class="orange-line">
        <div class="marquee__content">
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
            <span>Our Team</span>
        </div>
    </div>
</div>
<section class="our-team">
    <div class="container">
        <div class="team-wrapper">
            <div class="team-visible">
                <div class="row">
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Sergey Zasorin</div>
                            <div class="position">Founder</div>
                            <a href="https://www.linkedin.com/in/sergey-zasorin-1a2516152/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Anastasiia Mezieva</div>
                            <div class="position">HR</div>
                            <a href="https://www.linkedin.com/in/anastasiia-realis-3ba452223" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Kateryna Antonova</div>
                            <div class="position">Head of Community</div>
                            <a href="https://www.linkedin.com/in/kateryna-antonova-996655194" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Serhii Starchykov</div>
                            <div class="position">Backend Development</div>
                            <a href="https://www.linkedin.com/in/sergei-starchikov-334b24155" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Dmytro Holub</div>
                            <div class="position">Backend Development</div>
                            <a href="https://www.linkedin.com/in/holub-dmytro-5750a021a/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Andrew Havryliuk</div>
                            <div class="position">Frontend Development</div>
                            <a href="https://www.linkedin.com/in/abmin/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Yaroslav Maksymchuk</div>
                            <div class="position">Frontend Development</div>
                            <a href="https://www.linkedin.com/in/yaroslav-maksymchuk-434a54202/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Pavlo Zabuha</div>
                            <div class="position">Frontend Development</div>
                            <a href="https://www.linkedin.com/in/pavlo-zabuha-736aaa295/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 d-none d-lg-block">
                        <div class="person-card">
                            <div class="name">Yaroslav Polovnikov</div>
                            <div class="position">Frontend Development</div>
                            <a href="https://www.linkedin.com/in/yaroslav-polovnikov-19318a302/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="team-hidden" class:active={showAll}>
                <div class="row">
                    <div class="col-md-6 col-lg-4 d-lg-none">
                        <div class="person-card">
                            <div class="name">Yaroslav Polovnikov</div>
                            <div class="position">Frontend Development</div>
                            <a href="https://www.linkedin.com/in/yaroslav-polovnikov-19318a302/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Kyrylo Hatsenko</div>
                            <div class="position">Frontend Development</div>
                            <a href="https://www.linkedin.com/in/kyrylo-hatsenko-007a1b1a5/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Alexander Kornienko</div>
                            <div class="position">Unity</div>
                            <a href="https://www.linkedin.com/in/alexander-korniienko-61aa2a351/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Oleg Salamashenko</div>
                            <div class="position">Unity</div>
                            <a href="https://www.linkedin.com/in/oleg-salamashenko-56b226330" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Olexandr Koshoviy</div>
                            <div class="position">Unity</div>
                            <a href="https://www.linkedin.com/in/%D0%BE%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%80-%D0%BA%D0%BE%D1%88%D0%BE%D0%B2%D0%B8%D0%B9-7b430425a" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Dmytro Nikolaienko</div>
                            <div class="position">Unity</div>
                            <a href="https://www.linkedin.com/in/dmitry-nikolaenko-9389b3194/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Maksym Kharkheli</div>
                            <div class="position">Animation</div>
                            <a href="https://www.linkedin.com/in/maksym-kharkheli-aa0619156/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Yurii Litovskiy</div>
                            <div class="position">Design</div>
                            <a href="https://www.linkedin.com/in/yurii-litovskiy-84359b188" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Volodymyr Kishai</div>
                            <div class="position">Design</div>
                            <a href="https://www.linkedin.com/in/kishai/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Kateryna Pysulina</div>
                            <div class="position">Design</div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Andrey Sokolov</div>
                            <div class="position">Game Design</div>
                            <a href="https://www.linkedin.com/in/andrey-sokolov-6bb3b7206" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Yevhenii Dumenko</div>
                            <div class="position">Game Design</div>
                            <a href="https://www.linkedin.com/in/yevhenii-dumenko-84473722b/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Dmytro Bilozertsev</div>
                            <div class="position">QA</div>
                            <a href="https://www.linkedin.com/in/dmitry-belozertsev/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Pavlo Molchanov</div>
                            <div class="position">QA</div>
                            <a href="https://www.linkedin.com/in/pavlomolchanov/" class="link" target="_blank">
                                <IconifyIcon class="star-icon" icon={linkedin}/>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="person-card">
                            <div class="name">Vsevolod Yurisov</div>
                            <div class="position">Community</div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <a href="javascript:;" class="big-btn" on:click={() => {showAll = !showAll}}>
                    {#if !showAll}Show more{:else}Collapse{/if}<img src="{learnMore}">
                </a>
            </div>
        </div>
    </div>
</section>

<style lang="postcss">
    @import "../../../../../styles/global/scrollbar.pcss";

    .our-team {
        margin: 0 0 200px;
        position: relative;
        z-index: 4;
    }

    .our-team:before {
        content: "";
        height: 820px;
        width: 100%;
        background: rgba(255, 255, 255, 0.08);
        filter: blur(200px);
        position: absolute;
    }

    .lines-wrapper {
        overflow: hidden;
        height: 360px;
        padding-top: 200px;
        margin: 200px 0 50px;
    }

    .team-wrapper {
        position: relative;
        z-index: 2;
    }

    .background-line {
        width: calc(100% + 30px);
        background: #742B0D;
        height: 100px;
        padding: 32px 0;
        margin-left: -15px;
        overflow: hidden;
        position: relative;
        z-index: 3;
        transform: rotate(-1.5deg) translate(0, -66px);
    }

    .orange-line {
        width: calc(100% + 30px);
        background: #FF5D1C;
        height: 90px;
        font-size: 40px;
        color: white;
        line-height: 40px;
        padding: 26px 0;
        margin-left: -15px;
        font-family: 'Anton', sans-serif;
        letter-spacing: 2px;
        overflow: hidden;
        text-transform: uppercase;
        transform: rotate(4deg);
        margin-top: -160px;
        position: relative;
        z-index: 3;
    }

    .white-line .marquee__content {
        display: flex;
        padding-left: 0;
        -webkit-animation: marquee 20s infinite linear;
        animation: marquee 20s infinite linear;
    }

    .orange-line .marquee__content {
        display: flex;
        padding-right: 100%;
        -webkit-animation: marquee-right 20s infinite linear;
        animation: marquee-right 20s infinite linear;
    }

    .marquee__content span {
        padding: 0 40px;
        white-space: nowrap;
    }

    .white-line .marquee__content span:nth-child(odd) {
        color: white;
        -webkit-text-stroke: 1px #01070A;
    }

    .orange-line .marquee__content span:nth-child(odd) {
        color: #FF5D1C;
        -webkit-text-stroke: 1px #01070A;
    }

    @-webkit-keyframes marquee-right {
        0%{-webkit-transform: translate(-100%, 0);}
        100%{-webkit-transform: translate(0, 0);}
    }

    @keyframes marquee-right {
        0%{transform: translate(-100%, 0);}
        100%{transform: translate(0, 0)}
    }

    .person-card {
        background: rgba(40, 45, 57, 0.3);
        border-radius: 5px;
        padding: 20px 30px 30px;
        height: 165px;
        border: 2px solid #282D39;
        margin-bottom: 24px;
        position: relative;
        -webkit-backdrop-filter: blur(4px);
        backdrop-filter: blur(4px);
        transition: .25s;
        cursor: default;
    }

    .person-card:hover {
        filter: drop-shadow(0 0 70px rgba(170, 173, 248, 0.23));
        border-image: linear-gradient(to top, #25166d, #6367bf, #90a1f9);
        border-image-slice: 1;
    }

    .icon {
        width: 50px;
        height: 50px;
    }

    .name {
        font-size: 30px;
        line-height: 30px;
        font-family: 'Anton', sans-serif;
        margin: 20px 0 30px;
        color: white;
    }

    .position {
        font-size: 20px;
        line-height: 20px;
        color: #A0AEC0;
    }

    .link {
        color: #535761;
        font-size: 34px;
        position: absolute;
        bottom: 30px;
        right: 30px;
        transition: .25s;
    }

    .person-card:hover .link {
        color: white;
    }

    .team-hidden {
        min-width: 100%;
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        transition: max-height .25s ease-out;
    }

    .team-hidden.active {
        overflow: visible;
        max-height: 10000px;
        opacity: 1;
    }

    .big-btn {
        margin: 40px auto 0;
        position: relative;
        z-index: 4;
    }

    .big-btn.hidden {
        display: none;
    }

    @media(max-width: 1400px) {
        .lines-wrapper {
            margin: 100px 0 50px;
        }

        .name {
            margin: 5px 0 20px;
            line-height: 1.3;
        }
    }

    @media(max-width: 1199px) {
        .name {
            font-size: 24px;
        }

        .lines-wrapper {
            margin-top: 50px;
            margin-bottom: 0;
        }
    }

    @media(max-width: 991px) {
        .position {
            font-size: 18px;
        }

        .person-card {
            padding: 15px 15px 20px;
            height: 150px;
        }

        .link {
            font-size: 30px;
            bottom: 20px;
            right: 20px;
        }

        .icon img {
            max-width: 100%;
        }

        .orange-line {
            font-size: 26px;
            line-height: 28px;
            padding: 20px 0;
            height: 66px;
        }

        .background-line {
            height: 66px;
            transform: rotate(-3deg) translate(0, -92px);
        }

        .big-btn {
            margin-top: 15px;
        }
    }

    @media(max-width: 767px) {
        .lines-wrapper {
            margin-top: 0;
            height: 270px;
        }

        .team-wrapper {
            display: flex;
            overflow: auto;
            margin-right: -12px;
            @include scrollbar;
            @include scroll-smooth;
        }

        .team-hidden {
            min-width: initial;
            overflow: initial;
            margin-left: 24px;
            opacity: 1;
        }

        .team-wrapper :global(.big-btn) {
            display: none !important;
        }

        .team-wrapper :global(.row) {
            flex-wrap: nowrap;
        }

        .person-card {
            width: 270px;
            height: 120px;
            padding: 10px 20px 15px;
        }

        .team-wrapper :global(.row>*) {
            width: auto;
        }

        .our-team {
            margin: 0 0 160px;
        }

        .our-team:after {
            width: 100%;
            left: auto;
            top: -100px;
            background-size: 70%;
            right: 100%;
            margin-right: -190px;
        }

        .name {
            font-size: 20px;
            margin: 15px 0 20px;
        }

        .position {
            font-size: 15px;
        }

        .our-team:before {
            display: none;
        }
    }
</style>
